import { Link } from "react-router-dom"
import { useOutletContext } from "react-router-dom";


function MyCart() {
    const {setTab} = useOutletContext();

    console.log(setTab)
    return (
        <div className=" container pl-3 pr-3 mx-auto grid lg:grid-cols-6 grid-cols-1 lg:gap-10 gap-0">
            <div className="lg:col-span-2 col-span-1 ">
                <h1 className="font-bold text-lg gray-color1">My Cart</h1>
                <h3 className="red-color1 font-bold mt-5 mb-3">Campaign Details</h3>
                <Input text="Compaign Name" placeholder="Instagram, App - Banner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#cf102d">
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                </Input>
                <div className="flex sm:flex-row flex-col sm:gap-5 mt-5">
                    <Input text="Start date" placeholder="30/04/2022">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#cf102d">
                            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                    </Input>
                    <Input text="End date" placeholder="30/04/2022">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#cf102d">
                            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                    </Input>
                </div>
                <div className="flex gap-5 mt-5">
                    <ShowText innerText="New" outerText="status" />
                    <ShowText innerText="₹ 35,40,000" outerText="Total Price" active="active"/>
                </div>
            </div>
            <div className="lg:col-span-4 col-span-1 lg:mt-0 mt-10 grid grid-cols-1">
                <Header />
                <div className="grid sm:grid-cols-2 grid-cols-1 gap-5">
                    <Input2 text="Buy Type" options={["CPM" , "CPV"]} />
                    <Input2 text="Demographic" options={["Pin Code" , "City", "All India"]} />
                    <Input2 text="Gender" options={["Male", "Femail"]} />
                    <Input2 text="Affinity" options={["Banking & Finance", "Beauty & Wellness", "Food & Drinking", "New & Politics", "Technology", "Other"]} />
                    <Input2 text="In Market" options={["Apperal & Accesories", "Auto & vehical", "Bussniess Service", "Real Estate"]} />
                    <Input2 text="Life Event" options={["Busniss Creation", "Collage Graduate", "Job Change", "Marridge", "Other"]} />
                    <Input2 text="Vedio" options={["Skippible", "Non Skippible"]} />
                    <Input2 text="Geography" options={["Banking & Finance", "Beauty & Wellness", "Food & Drinking", "New & Politics", "Technology", "Other"]} />
                </div>
                <CostCart setTab={setTab} />
            </div>
        </div>
    )
}

function CostCart({setTab}) {
    return (
        <div className="mt-16 mb-16 gray-color2  p-5 rounded-lg">
            <div className="flex items-center justify-between">
                <h1 className="font-bold text-lg">Cost Estimates</h1>
                <div className="red-color1 font-bold">
                    <p className="text-2xl">$ 35,40,000</p>
                    <p className="text-xs">Total Est, (inc, taxes)</p>
                </div>
            </div>
            <div className="mt-3 flex gap-5">
                <div>
                    <h1 className="font-bold gray-color1 text-md">Best Prices</h1>
                    <p className="font-semibold text-zinc-500 text-xs">$ 3,400,333</p>
                </div>
                <div className="">
                    <h1 className="font-bold gray-color1 text-md">#Units</h1>
                    <div className="flex gap-3 items-center units mt-1 p-2 bg-white">
                        <input className="font-semibold w-12 text-zinc-500 text-xs bg-transparent" type="text" placeholder="2000000" />
                        <div className="flex gap-2">
                            <div className="h-3 w-3 rounded-full active-button"></div>
                            <div className="h-3 w-3 rounded-full active-button"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3 mb-3 flex items-center justify-between">
                <div>
                    <h1 className="font-bold gray-color1 text-md">Sub Total</h1>
                    <p className="font-semibold text-zinc-500 text-xs">$ 15 * 200000</p>
                </div>
                <h1 className="font-bold gray-color1 text-md">$ 30,000,000</h1>
            </div>
            <div className="mt-3 mb-3 flex items-center justify-between">
                <div>
                    <h1 className="font-bold gray-color1 text-md">GST</h1>
                </div>
                <h1 className="font-bold gray-color1 text-md">$ 5,0,000</h1>
            </div>
            <Link to="/payment/scadual">
                <div onClick={() => setTab(2)} className="font-semibold sm:mx-0 mx-auto gap-3 pl-10 pr-10 pt-2 pb-2 rounded-3xl visited w-56 text-center  mt-10">
                    Save Campaign
                </div>
            </Link>
        </div>
    )
}

function Header() {
    return (
        <div>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-5">
                    <input type="checkbox" />
                    <h1 className="font-bold text-lg gray-color1">Instagram, App - Banner</h1>
                </div>
                <div className="flex sm:flex-row flex-col gap-5">
                    <HeaderButton text="Core">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                            <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
                        </svg>
                    </HeaderButton>
                    <HeaderButton text="Delete">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                        </svg>
                    </HeaderButton>
                </div>
            </div>
            <div className=" flex items-center justify-between">
                <h3 className="red-color1 font-bold mt-2 mb-3">Targetting Parameters</h3>
                <h3 className="red-color1 font-bold mt-2 mb-3 underline">Reset</h3>
            </div>
        </div>
    )
}

function HeaderButton({children, text}) {
    return (
        <div className="flex font-semibold items-center gap-3 pl-5 pr-5 pt-2 pb-2 rounded-3xl active-button">
            {children}
            <p>{text}</p>
        </div>
    )
}

function Input({text, placeholder, children}) {
    return (
        <div>
            <h4 className="text-sm font-semibold gray-color1">{text}</h4>
            <div className="p-3 mt-3 flex rounded-md w-full gray-color3">
                <input style={{width:"20%"}} className="flex-1 w-auto mr-3 bg-transparent" type="text" placeholder={placeholder} />
                {children}
            </div>
        </div>
    )
}

function Input2({text, options}) {
    return (
        <div>
            <h4 className="text-sm font-semibold gray-color1">{text}</h4>
            <div className="mt-3 p-1 flex rounded-md w-full gray-color3">
                <select style={{width:"20%"}} className="selection flex-1 w-auto mr-3  outline-none border-none bg-transparent">
                    {options && options.map((value, index) => 
                        <option className="" key={index}>{value}</option>
                    )}
                </select>
            </div>
        </div>
    )
}

function ShowText({outerText, innerText, active}) {
    return (
        <div className="flex-1">
            <h4 className="text-sm font-semibold gray-color1">{outerText}</h4>
            <div className={`p-3 mt-3 flex rounded-md w-full font-semibold gray-color2 ${active}`}>
                {innerText}
            </div>
        </div>
    )
}

export default MyCart;